export default "__VITE_ASSET__Cs_X8AKy__"